var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.4252,
    cy: 20.3157,
    rx: 20.1519,
    ry: 20.1526,
    fill: "#9378C5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0766 10.498H21.9762C20.6058 10.498 19.2914 11.0425 18.3224 12.0115C17.3533 12.9806 16.8089 14.2949 16.8089 15.6654V18.7658H13.7085V22.8996H16.8089V31.1674H20.9428V22.8996H24.0432L25.0766 18.7658H20.9428V15.6654C20.9428 15.3913 21.0516 15.1284 21.2455 14.9346C21.4393 14.7408 21.7021 14.6319 21.9762 14.6319H25.0766V10.498Z",
    stroke: "white",
    strokeWidth: 1.7524,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.e634448e8391c65fb0fbd423c23c36ad.svg";
export { ForwardRef as ReactComponent };